import { LoadingFallback } from '@/components/LoadingFallback';
import { forceMobileSessionsAtom } from '@/lib/atoms';
import { isMobileDevice } from '@/lib/isMobileDevice';
import { useAtom } from 'jotai';
import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import StepsPage from './steps';

// Lazy-loaded: keeps qrcode.react out of the eager mobile-critical chunk
// (the QR landing is a desktop-only page).
const QrLandingPage = lazy(() => import('./qr-landing'));

/**
 * Session index (`/:sessionId`): mobile/tablet → capture steps; desktop → QR
 * landing. Same URL for both paths (no ?qr=true). "Continue on this device"
 * on the QR landing forces the capture flow so a misclassified device is
 * never stranded. Override is persisted per sessionId via jotai atomWithStorage.
 */
const SessionEntryPage = () => {
  const { sessionId } = useParams<{ sessionId: string }>();
  const [forceMap, setForceMap] = useAtom(forceMobileSessionsAtom);
  const forceMobile = Boolean(sessionId && forceMap[sessionId]);

  const onContinueHere = () => {
    if (!sessionId) return;
    setForceMap({ ...forceMap, [sessionId]: true });
  };

  if (forceMobile || isMobileDevice()) {
    return <StepsPage />;
  }

  return (
    <Suspense fallback={<LoadingFallback />}>
      <QrLandingPage onContinueHere={onContinueHere} />
    </Suspense>
  );
};

export default SessionEntryPage;
